import LaunchIcon from '@mui/icons-material/Launch';
import Button from '@mui/material/Button';
import { Image } from 'mui-image';
type Value = string | null | { src: string };
interface FileManagerInputPreviewProps {
    value: Value;
    mode?: 'image' | 'file';
}

const FileManagerInputPreviewSrc = (value: Value): string | null => {
    if (value && 'object' === typeof value && value.src) {
        return value.src;
    } else if ('string' === typeof value) {
        return value;
    }
    return null;
}

const FileManagerInputPreview = ({ value, mode }: FileManagerInputPreviewProps) => {
    const src = FileManagerInputPreviewSrc(value);
    if (src) {
        if ('image' === mode) {
            return <a href={src} target="_blank" rel="noreferrer" title="Open image in new window">
                <Image style={{ padding: 3, objectFit: 'contain' }} src={src} width={"100%"} />
            </a>
        } else {
            return <a href={src} target="_blank" rel="noreferrer" title="Open in new window">
                <Button variant="outlined" startIcon={<LaunchIcon />}>Link</Button>
            </a>
        }
    } else {
        return null;
    }
}

export default FileManagerInputPreview;